import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface CancelBackButtonProps {
  to?: string | number; // Route path or -1 for back navigation
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
}

const CancelBackButton: React.FC<CancelBackButtonProps> = ({
  to = -1,
  disabled = false,
  onClick,
  label = "Cancel",
}) => {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event);
    } else if (typeof to === "number" && to === -1) {
      navigate(-1);
    } else if (typeof to === "string") {
      navigate(to);
    }
  };

  return (
    <Button
      variant="outline-secondary"
      style={{
        color: "#878899",
        borderColor: "#B0BAC9",
        backgroundColor: "transparent",
      }}
      onClick={handleClick}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default CancelBackButton;

